// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".receipt-table[data-v-6bc858fd] .el-drawer__header{margin-bottom:0}.receipt-table[data-v-6bc858fd] .el-drawer__body{padding-top:0}.receipt-table[data-v-6bc858fd] .avue-crud__left{-webkit-box-flex:1;-ms-flex:1;flex:1}.receipt-table[data-v-6bc858fd] .el-table__body-wrapper.is-scrolling-left{z-index:2}", ""]);
// Exports
module.exports = exports;
